import React, { useState } from 'react';
import { useParams } from 'react-router';
import { strings } from '/imports/strings';
import { Account, Accounts, updateAccountProfile } from '/imports/api/accounts';
import { Orgs } from '/imports/api/orgs';
import { PhoneInput } from '/imports/ui/PhoneInput';
import { Page } from '/imports/ui/Page';
import { PageHeading } from '/imports/ui/PageHeading';
import { PageBody } from '/imports/ui/PageBody';
import { useFindOne, useSubscribed } from '/imports/hooks';
import { Publications } from '/imports/publications';
import { NotFoundPage } from '/imports/ui/NotFoundPage';
import { AutoForm } from '/imports/ui/AutoForm';
import { LoadingFlex } from '/imports/ui/LoadingFlex';

export const AccountProfilePage = () => {
  const { accountId } = useParams<any>();
  const [update, setUpdate] = useState<Partial<Account>>({ _id: accountId });
  const loading = useSubscribed(Publications.listMyOrgs);
  const document = useFindOne(() => Accounts.find(accountId), [accountId, loading]);
  const org = useFindOne(() => Orgs.find(document?.orgId), [document?.orgId, loading]);
  if (!document) return <NotFoundPage />;
  return (
    <Page className={`page${loading ? ' initializing' : ''}`}
      breadcrumbs={[{ path: '/profile', label: strings.Profile() }, { path: `/profile/${accountId}`, label: org?.name || '' }]}
    >
      <PageHeading
        left={<h1>{org?.name} {strings.Profile()}</h1>}
      />
      <PageBody>
        {
          loading ?
            <LoadingFlex />
            :
            <AutoForm
              createMethod={updateAccountProfile as any}
              updateMethod={updateAccountProfile as any}
              document={document}
              update={update}
              setUpdate={setUpdate}
              form={[
                [{ field: 'firstName' }, { field: 'lastName' }],
                [{ field: 'email' }, { field: 'phone', input: { type: PhoneInput } }],
              ]}
              redirect={'/profile'}
            />
        }
      </PageBody>
    </Page>
  );
};